import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sim-train-tree-view',
  template: require('./sim-train-tree-view.component.html'),
  styles: [require('./sim-train-tree-view.component.sass')]
})
export class SimTrainTreeViewComponent implements OnInit {


  constructor() { }

  ngOnInit(): void {
  }

}
